<template>
  <div>
      
    <div class="booking-steps" :style="clientStyle">
      <div class="step-actions" >
        <v-icon  @click="step--" color="black"  v-show="step != 1">mdi-arrow-left</v-icon>
        <v-spacer></v-spacer>
        <v-icon  @click="cancelBooking" color="black" >mdi-close</v-icon>
      </div>

      <div class="booking-steps-brand">
        <img :src="$store.state.core.widgetParameters.logo" :alt="$store.state.core.widgetParameters.botName">
      </div>

      <div class="stepper-progress">
          <div class="stepper-state">
            <span class="page">Step {{ step }} of 3 : </span> <span class="title">{{ stepData.name }}</span>
          </div>
          <div class="progress" :style="`--step:${step * 33.33}%`"></div>
      </div>
      <v-stepper v-model="step" alt-labels elevation="0" v-if="this.$store.state.bookingSteps.stepsData.step1" v-ripple="false">
        <v-stepper-header>
          <v-stepper-step
              :complete="step > 1"
              step="1"
              :editable="step > 1"
          >
            <div class="step-img">
              <img :src="cardData.step1.icon" width="25" alt="">
            </div>
            <p class="mb-0 text-center d-block">{{cardData.step1.name}}</p>
          </v-stepper-step>

          <v-divider></v-divider>
          

          <v-stepper-step
              :complete="step > 2"
              step="2"
              :editable="step > 2"
          >
            <div class="step-img">
              <img :src="cardData.step2.icon" width="25" alt="">
            </div>
            <p class="mb-0 text-center d-block">{{cardData.step2.name}}</p>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            <div class="step-img">
              <img :src="cardData.step3.icon" width="25" alt="">
            </div>
            <p class="mb-0 text-center">{{cardData.step3.name}}</p>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">

            <step1 @nextStep="step++" @cancel="cancelBooking"/>
          </v-stepper-content>

          <v-stepper-content step="2">
            <step2 @nextStep="step++" v-if="step >1" @cancel="cancelBooking"/>
          </v-stepper-content>

          <v-stepper-content step="3">
            <step3 v-if="step >2" @submitBooking="submitBooking" @cancel="cancelBooking"/>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

    </div>
  </div>


</template>

<script>
import step1 from "./step1/step1";
import step2 from "./step2/step2"
import step3 from "./step3/step3";
import locale from "../../../configs/locale";
export default {
  name: "BookingSteps",
  components: {
    step1,
    step2,
    step3,

  },
  data() {
    return {
      step: 1,
      expired: false,
    }
  },
  props: {
    cardData: {
      type: Object,
      default: ()=> {
        return {}
      }
    }
  },
   mounted() {
     this.$store.dispatch('setStepsData', this.cardData)
     let lang = locale.find(item=>{
       return item.name === this.cardData.lang
     })
     this.$store.state.core.widgetParameters.lang = lang.code
     this.$store.state.core.locale= lang.code
     this.$i18n.locale = lang.code

  },
  methods: {
    async getCardData () {

    },
    async submitBooking () {

      try {
        this.$emit('postBack',this.$store.state.bookingSteps.selectedStepsData)
      }catch (e) {
        console.log(e)
      }
    },
    async cancelBooking() {
      this.$emit('postCustom', {
        type: 'message',
        text: "cancel_all_dialogs",
        cancelRedirectBlock: this.cardData.cancelRedirectBlock,
      })
    },
  },

  computed: {
    clientStyle() {
      return {
        "--secondary-color": this.$store.state.core.widgetParameters.introButtonsColor
      };
    },
    stepData() {
      return this.$store.state.bookingSteps.stepsData[`step${this.step}`]
    },
  },
}
</script>

<style lang="scss">
/* Base styles */
.w-full { width: 100%; }
.text-scondary { color: var(--secondaryColor) !important; }

/* Container styles */
#botter-widget .container { padding-inline: 24px !important; }

/* Booking steps core styles */
.booking-steps {
  position: relative;

  ::-webkit-scrollbar {
    width: 0;
    &-track { background: #f1f1f1; }
    &-thumb {
      background: #888;
      &:hover { background: #555; }
    }
  }

  h2 { margin-bottom: 15px; }

  .logo {
    margin-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img { height: 47px; }
  }
}

/* Brand and card styles */
.booking-steps-brand {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  position: relative;
  margin-top: -40px;
  img {
    max-height: 40px;
    max-width: 100%;
  }
}

.cardTitle {
  color: var(--secondaryColor);
  font-weight: 600;
  font-size: 22px;
}

/* Stepper progress styles */
.stepper-progress {
  .stepper-state {
    display: flex;
    justify-content: end;
    align-items: center;
    font-size: 16px;
    padding: 10px 40px;
    font-weight: 600;
    gap: 4px;
    .page { color: var(--primaryColor); }
    .title { color: #9099A9; }
  }

  .progress {
    position: relative;
    height: 3px;
    width: 100%;
    background-color: #eee;
    
    &::before {
      content: '';
      position: absolute;
      width: var(--step);
      height: 3px;
      background-color: var(--secondaryColor);
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      transition: width .5s ease;
    }
  }
}

/* Step actions styles */
.step-actions {
  padding: 10px 35px 0;
  position: relative !important;
  z-index: 10;
  width: 100% !important;
  box-sizing: border-box !important;
  justify-content: space-between;
  display: flex;
  top: 16px !important;
  margin-bottom: 30px !important;
}

/* Stepper styles */
.v-stepper {
  box-shadow: none !important;
  
  &__content { padding: 0 !important; }
  &__wrapper {
    border-top: none !important;
    padding-top: 15px;
    box-sizing: border-box;
  }
  
  &__header {
    display: none !important;
    box-shadow: none !important;
    max-width: 775px;
    margin: auto;

    .v-stepper__step__step { display: none; }
    
    .v-divider {
      border-color: var(--secondaryColor) !important;
      background-color: var(--secondaryColor) !important;
      border-width: 1px;
      border-radius: 4px;
      margin: 52px -160px 0 !important;
    }

    .v-stepper__label {
      .step-img {
        display: flex;
        width: 50px;
        margin: auto;
        height: 50px;
        border: 2px solid #c7c7c7;
        border-radius: 100%;
        align-content: center;
        background: white;
        z-index: 1000;
        
        img {
          margin: auto;
          width: 25px;
          filter: brightness(0) invert(.8);
        }
      }

      p {
        color: #c7c7c7;
        font-size: 14px;
        margin-top: 8px;
        width: 100%;
      }
    }
  }

  .v-item-group{
    height: calc(100vh - 285px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;;
    @media screen and (max-width: 959px) {
      height: calc(100vh - 220px) !important;
    }
  }
}

/* Active and complete step styles */
.v-stepper__step {
  &--active .v-stepper__label {
    .step-img {
      border: 2px solid var(--secondaryColor);
      background: white;
      filter: none;
      img { filter: none; }
    }
    p { color: var(--secondaryColor); }
  }

  &--complete .v-stepper__label {
    .step-img {
      border: 2px solid var(--secondaryColor);
      background: var(--secondaryColor);
      filter: none;
      img { filter: brightness(0) invert(1) !important; }
    }
    p { color: var(--secondaryColor); }
  }
}

/* Navigation styles */
.step-nav {
  height: 100px;
  background: white;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: none !important;

  .v-btn {
    width: 250px;
    height: 50px !important;
    border-radius: 10px;
    text-transform: capitalize;
    font-size: 17px;
    margin: 0 10px;
    letter-spacing: 0;
    
    &.primary { background: var(--secondaryColor) !important; }
  }
}

.stepper-padding { padding-bottom: 125px; }

/* Utility classes */
::v-deep .v-stepper__header .v-ripple__container { display: none !important; }
.v-stepper--alt-labels .v-stepper__step { flex-basis: auto !important; }
.theme--light.v-stepper .v-stepper__step--editable:hover { background: transparent !important; }

/* Media queries */
@media (min-width: 1200px) {
  .booking-steps .logo {
    position: absolute;
    z-index: 1000;
    max-width: 300px;
    top: 15px;
    left: 0;
  }
  
  .rtl .booking-steps .logo {
    right: 0;
    left: auto;
  }
}

@media only screen and (max-width: 959px) {
  .booking-steps-brand { display: none; }
  
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label { display: block !important; }
  
  .step-actions {
    top: 0 !important;
    position: relative !important;
    padding: 24px 16px !important;
    box-sizing: border-box !important;
    margin-bottom: 0 !important;
  }
  
  .stepper-progress .stepper-state {
    justify-content: center;
    margin-top: -50px;
    margin-bottom: 6px;
  }
}

@media only screen and (max-width: 800px) {
  .step-nav {
    height: 80px;
    .v-btn {
      width: calc(50% - 30px) !important;
      height: 40px !important;
      font-size: 15px;
    }
  }
}
</style>
